import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ServiceUtil } from '../utilities/service.util';
import { AuditWebEventTrackerModel } from '../models/audit-tracking.model';

@Injectable()
export class WebEventTrackingService {
	_controllerName: string = 'ActionTracker';

	constructor(private _serviceUtil: ServiceUtil, private http: HttpClient) { }

	async trackUserAction(auditWebEventTrackerModel: AuditWebEventTrackerModel)	{
		var auditWebEventTrackerModels: AuditWebEventTrackerModel[] = [];
		auditWebEventTrackerModels.push(auditWebEventTrackerModel);

		return await this._serviceUtil.doPostRequestAsync<any, string>(this._controllerName, 'TrackWebEvents', auditWebEventTrackerModels);
	}

	async trackUserActions(auditWebEventTrackerModels: AuditWebEventTrackerModel[]) {
		this._serviceUtil.doPostRequestAsync<any, string>(this._controllerName, 'TrackWebEvents', auditWebEventTrackerModels);
	}
}
